import * as tracking from "../../booking/helpers/tracking"
import * as cookieNames from "../../booking/constants/Cookies"
import * as cookieHelper from "../../helpers/cookie"
import { Cookies } from "react-cookie"

export default class PanningMapTracking {
  constructor(el) {
    const self = this
    self.elem = el
    self.elem.mapMarkers = el.querySelectorAll(".map-marker--parking")
    self.elem.mapMarkerButtons = el.querySelectorAll(".js-map-marker-parking-button")
    self.elem.locale = el.dataset.locale ?? (document.body && document.body.dataset.language)
    self.init()
    return this
  }
  init() {
    const self = this
    self.addEventListeners()
  }

  addEventListeners() {
    const self = this
    if (self.elem.mapMarkers && self.elem.mapMarkers.length > 0) {
      self.elem.mapMarkers.forEach((elem) => {
        elem.addEventListener("click", (e) => this.handlePinClick(e))
      })
    }
    if (self.elem.mapMarkerButtons && self.elem.mapMarkerButtons.length > 0) {
      self.elem.mapMarkerButtons.forEach((elem) => {
        elem.addEventListener("click", (e) => this.handleMapMarkerButtonClick(e))
      })
    }
  }

  handlePinClick = (e) => {
    //track map marker click
    var outerWrapper = e.target.closest("div.js--panning-map-interactive > div")
    var productName = outerWrapper.querySelector(".title").innerText
    tracking.trackParkingEngagementClick("parking - map", `pin - click - ${productName}`)
  }

  handleMapMarkerButtonClick = (e) => {
    const self = this

    //track button click
    e.stopPropagation()
    var outerWrapper = e.target.closest("div.js--panning-map-interactive > div")
    var productName = outerWrapper.querySelector(".title").innerText
    tracking.trackParkingEngagementClick("parking - map", `gå til booking - click - ${productName}`)

    //track booking starter modal page view
    const cookies = new Cookies()
    const userId = cookies.get(cookieNames.IDP_USER_ID)
    let bookingStarterData = {
      pageBusinessunit: "parking",
      virtualPath: tracking.getVirtualPath("/virtual/(|en/|sv/)parkering/dates", self.elem.locale),
      event: "track-vp",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) bookingStarterData.userId = userId
    window.dataLayer.push(bookingStarterData)
  }
}
